import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { HelpersService } from '../../shared/servicio/helpers/helpers.service';
import { NgForm, FormControl } from '@angular/forms';
import { AdminService } from '../services/admin/admin.service';

declare var $: any;

@Component({
  selector: 'app-banners',
  templateUrl: './banners.component.html',
  styleUrls: ['./banners.component.css'],
})
export class BannersComponent implements OnInit {
  baseImgURL;
  searchTextFC: FormControl;

  // Lista de banners
  list_banner: any[] = [];

  // Paginación
  currentPage: number = 1;
  pageSize: number = 10;
  totalPages: number = 0;
  totalItems: number = 0;

  // Variables para compatibilidad con el template
  p: number = 1;
  itemsPagina: number = 10;
  totalpages: number = 0;

  // Filtros
  activeFilter: boolean | undefined = true; // Por defecto solo activos
  searchFilter: string = '';

  showLoading: boolean = false;

  constructor(
    private _http: HttpClient,
    public helper: HelpersService,
    private adminService: AdminService
  ) { }

  ngOnInit() {
    console.log('BannersComponent initialized');
    this.showLoading = true;
    this.baseImgURL = environment.baseImageUrl;

    // Inicializar controles de formulario
    this.searchTextFC = new FormControl('');

    this.loadBanners();

    // Ya no nos suscribimos automáticamente a los cambios del input
    // this.searchTextFC.valueChanges.subscribe(...) - REMOVIDO
  }

  loadBanners() {
    this.showLoading = true;

    this.adminService.listBanners(
      this.currentPage,
      this.pageSize,
      this.activeFilter,
      this.searchFilter
    ).subscribe({
      next: (response: any) => {
        console.log('Response from backend:', response);

        // Manejar tanto formato paginado como array directo
        if (Array.isArray(response)) {
          this.list_banner = response;
          this.totalItems = response.length;
          this.totalPages = 1;
        } else {
          this.list_banner = response.results || [];
          this.totalItems = response.count || 0;
          this.totalPages = Math.ceil(this.totalItems / this.pageSize);
        }

        // Variables para compatibilidad con el template de paginación
        this.totalpages = this.totalItems;
        this.itemsPagina = this.pageSize;

        // Procesar datos para compatibilidad con el template
        this.list_banner = this.list_banner.map(banner => ({
          ...banner,
          user_id__first_name: banner.created_by_name ? banner.created_by_name.split(' ')[0] : '',
          user_id__last_name: banner.created_by_name ? banner.created_by_name.split(' ').slice(1).join(' ') : '',
          date_created: this.formatDate(banner.date_created)
        }));

        console.log('Processed banners:', this.list_banner);
        console.log('Total items:', this.totalItems);

        this.showLoading = false;
      },
      error: (error) => {
        console.error('Error loading banners:', error);
        this.helper.error('Error al cargar banners', error);
        this.showLoading = false;
      }
    });
  }

  // Nuevo método para alternar filtro de estado
  toggleStatusFilter() {
    if (this.activeFilter === true) {
      this.activeFilter = false; // Cambiar a solo inactivos
    } else if (this.activeFilter === false) {
      this.activeFilter = undefined; // Cambiar a todos
    } else {
      this.activeFilter = true; // Cambiar a solo activos
    }

    this.currentPage = 1;
    this.p = 1;
    this.loadBanners();
  }

  // Método para obtener el texto del estado actual del filtro
  getStatusFilterText(): string {
    if (this.activeFilter === true) {
      return 'SOLO ACTIVOS';
    } else if (this.activeFilter === false) {
      return 'SOLO INACTIVOS';
    } else {
      return 'TODOS';
    }
  }

  // Método para obtener el ícono del estado actual del filtro
  getStatusFilterIcon(): string {
    if (this.activeFilter === true) {
      return 'assets/img/icons/icon-order-doctor-activated.png';
    } else if (this.activeFilter === false) {
      return 'assets/img/icons/icon-order-doctor-deactivated.png';
    } else {
      return 'assets/img/icons/icon-filter.png';
    }
  }

  // Método para obtener la clase CSS del botón según el estado
  getStatusFilterClass(): string {
    if (this.activeFilter === true) {
      return 'bg-success text-white';
    } else if (this.activeFilter === false) {
      return 'bg-danger text-white';
    } else {
      return 'bg-white text-mefid-purple1';
    }
  }
  applySearchFilter() {
    const searchValue = this.searchTextFC.value || '';
    this.searchFilter = searchValue.trim();
    this.currentPage = 1;
    this.p = 1;
    this.loadBanners();
  }

  // Método para limpiar filtros
  clearFilters() {
    this.searchTextFC.setValue('');
    this.searchFilter = '';
    this.activeFilter = true; // Volver al estado por defecto (solo activos)
    this.currentPage = 1;
    this.p = 1;
    this.loadBanners();
  }

  // Método para detectar Enter en el input de búsqueda
  onSearchKeyPress(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.applySearchFilter();
    }
  }

  // Formatear fecha para mostrar
  formatDate(dateString: string): string {
    if (!dateString) return '';

    const date = new Date(dateString);
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    };

    return date.toLocaleDateString('es-ES', options);
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.p = page;
    this.loadBanners();
  }

  // Métodos legacy removidos (onActiveToggle, onInactiveToggle, updateActiveFilter)
  // Ya no son necesarios con el nuevo sistema de filtros

  // Método para manejar eventos de componentes hijos
  onListUpdate(updated: boolean) {
    if (updated) {
      this.loadBanners();
    }
  }

  // Métodos legacy para mantener compatibilidad
  getPage(page: number) {
    this.onPageChange(page);
  }

  actualizar_lista(event: boolean) {
    this.onListUpdate(event);
  }

  // Método para obtener el estado del banner
  getBannerStatus(banner: any): string {
    if (!banner.active) {
      return 'Inactivo';
    }

    const now = new Date();
    const startDate = new Date(banner.start_date);
    const endDate = new Date(banner.end_date);

    if (now < startDate) {
      return 'Programado';
    } else if (now > endDate) {
      return 'Expirado';
    } else {
      return 'Activo';
    }
  }

  // Método para obtener clase CSS según el estado
  getStatusClass(banner: any): string {
    const status = this.getBannerStatus(banner);
    switch (status) {
      case 'Activo':
        return 'text-success';
      case 'Programado':
        return 'text-warning';
      case 'Expirado':
        return 'text-danger';
      case 'Inactivo':
        return 'text-muted';
      default:
        return 'text-muted';
    }
  }

  // Método para obtener el texto descriptivo del filtro actual
  getFilterDescription(): string {
    let description = '';

    if (this.activeFilter === true) {
      description += 'Solo banners activos';
    } else if (this.activeFilter === false) {
      description += 'Solo banners inactivos';
    } else {
      description += 'Todos los banners';
    }

    if (this.searchFilter) {
      description += ` - Búsqueda: "${this.searchFilter}"`;
    }

    return description;
  }
}
